import { renderAuthors } from "../views/resource/parts/properties";

const formatPerson = (author, includeInstitution, withParentheses) => {
  // if (!author.firstName && !author.lastName) return "Malformed Data";

  // const fullname = author.firstName + " " + (author.middleName ? author.middleName + " " : "") + author.lastName;
  // const institution = includeInstitution !== false && author.institution
  //   ? withParentheses !== true
  //     ? ", " + author.institution.name
  //     : " (" + author.institution.name + ")"
  //   : "";

  // return fullname + institution;
  if (!author.name) return "Malformed Data";
  const organization =
    includeInstitution && author.organization
      ? withParentheses !== true
        ? ", " + author.organization.name
        : " (" + author.organization.name + ")"
      : "";
  return author.name + organization;
};

const formatAuthor = (author, includeInstitution, withParentheses) => {
  // switch (author.type) {
  //   case "person":
  //     return author.person && formatPerson(author.person, includeInstitution, withParentheses);
  //   case "institution":
  //     return author.institution ? author.institution.name : "";
  //   case "group":
  //     return author.group ? author.group.name : "";
  //   case "other":
  //     return author.other;
  //   default:
  //     return formatPerson(author, includeInstitution, withParentheses);
  // }
  switch (author.discriminator) {
    case "organization":
      return author.organization.name;
    case "person":
      return formatPerson(author.person, includeInstitution, withParentheses);
    default:
      return null;
  }
};

const formatAuthorType = (author) => {
  switch (author.discriminator) {
    case "person":
      return "Person";
    case "organization":
      return "Organization";
    default:
      return null;
  }
};

const formatImage = (image, format) => {
  if (!image) return null;

  if (image.formats && format) {
    if (format === "thumbnail")
      return (
        image.formats["thumbnail"] ||
        image.formats["small"] ||
        image.formats["medium"] ||
        image.formats["large"] ||
        image
      ).url;
    if (format === "small")
      return (
        image.formats["small"] ||
        image.formats["medium"] ||
        image.formats["large"] ||
        image
      ).url;
    if (format === "medium")
      return (image.formats["medium"] || image.formats["large"] || image).url;
    if (format === "large") return (image.formats["large"] || image).url;
  }

  return image.url;
};

const formatTextbookTitle = (textbook, shortForm = false) => {
  let title = `${textbook.name}${textbook.meta.subtitle ? `: ${textbook.meta.subtitle}` : ""}`;

  if (shortForm !== true) {
    title += `${textbook.meta.edition ? ` - ${textbook.meta.edition}` : ""}${textbook.contributors["relator/pbl"] ? ` (${renderAuthors(textbook.contributors["relator/pbl"])})` : (textbook.meta.publisher ?? "")}`;
  }

  return title;
};

const formatResourceTitle = (resource) => {
  let title = `${resource.name}${resource.meta?.subtitle ? `: ${resource.meta.subtitle}` : ""}${resource.meta?.edition ? ` (${resource.meta.edition})` : ""}`;

  return title;
};
export {
  formatAuthor,
  formatPerson,
  formatAuthorType,
  formatImage,
  formatTextbookTitle,
  formatResourceTitle,
};
